import { useEffect, useRef, useState } from "react";

//helpers
import getImg from "helpers/getCloudinaryImage";
import { Img } from "react-image";

// icons
import SvgArrowLeftWhite from "assets/icons/js/SvgArrowLeftWhite";
import SvgArrowRightWhite from "assets/icons/js/SvgArrowRightWhite";
import SvgCrossWhite from "assets/icons/js/SvgCrossWhite";

// styles
import "./style.scss";

const Gallery = ({
	open,
	setOpen,
	images,
	imageText = null,
	clickedImageIndex = 0,
	breakpoint = 900,
}) => {
	const close = (e) => {
		setOpen(false);
		e.stopPropagation();
	};

	const [index, setIndex] = useState(clickedImageIndex);

	useEffect(() => {
		let zoomElement;
		if (document) {
			zoomElement = document.createElement("meta");
			zoomElement.name = "viewport";
			zoomElement.content =
				"width=device-width, initial-scale=1, user-scalable=yes";
			document.head.appendChild(zoomElement);
		}
		return () => {
			document.head.removeChild(zoomElement);
		};
	}, [open]);

	if (!open) {
		return null;
	}

	if (imageText) {
		return (
			<ImageTextGallery
				open={open}
				setOpen={setOpen}
				images={images}
				imageText={imageText}
				clickedImageIndex={clickedImageIndex}
				breakpoint={900}
			/>
		);
	}

	return (
		<div className="__gallery">
			<SvgCrossWhite id="gallery__cross" onClick={close} />
			<div className="gallery__arrows">
				<SvgArrowLeftWhite
					onClick={(e) => {
						e.stopPropagation();
						if (index > 0) setIndex(index - 1);
						else setIndex(images.length - 1);
					}}
				/>
				<SvgArrowRightWhite
					onClick={(e) => {
						e.stopPropagation();
						if (index < images?.length - 1) setIndex(index + 1);
						else setIndex(0);
					}}
				/>
			</div>
			<div
				className="gallery__images"
				// onScroll={(e) => handleScroll(e)}
			>
				<div className="gallery__images-image" key={index}>
					<Img
						decode={false}
						loading="lazy"
						loader={
							<span
								style={{
									margin: "auto",
									display: "block",
									color: "white",
									transform: "scale(0.5)",
								}}
							>
								<Loader />
							</span>
						}
						src={getImg({
							id: images[index]?.imageId
								? images[index]?.imageId
								: images[index],
							version: "1636374075",
							quality:"25"
						})}
						alt=""
					/>
				</div>
			</div>
		</div>
	);
};

const Loader = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{
				margin: "auto",
				background: "rgba(255, 255, 255, 0)",
				display: "block",
				shapeRendering: "auto",
			}}
			width="200px"
			height="200px"
			viewBox="0 0 100 100"
			preserveAspectRatio="xMidYMid"
		>
			<g transform="translate(80,50)">
				<g transform="rotate(0)">
					<circle cx="0" cy="0" r="6" fill="#ffffff" fill-opacity="1">
						<animateTransform
							attributeName="transform"
							type="scale"
							begin="-0.875s"
							values="1.5 1.5;1 1"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
						></animateTransform>
						<animate
							attributeName="fill-opacity"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
							values="1;0"
							begin="-0.875s"
						></animate>
					</circle>
				</g>
			</g>
			<g transform="translate(71.21320343559643,71.21320343559643)">
				<g transform="rotate(45)">
					<circle cx="0" cy="0" r="6" fill="#ffffff" fill-opacity="0.875">
						<animateTransform
							attributeName="transform"
							type="scale"
							begin="-0.75s"
							values="1.5 1.5;1 1"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
						></animateTransform>
						<animate
							attributeName="fill-opacity"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
							values="1;0"
							begin="-0.75s"
						></animate>
					</circle>
				</g>
			</g>
			<g transform="translate(50,80)">
				<g transform="rotate(90)">
					<circle cx="0" cy="0" r="6" fill="#ffffff" fill-opacity="0.75">
						<animateTransform
							attributeName="transform"
							type="scale"
							begin="-0.625s"
							values="1.5 1.5;1 1"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
						></animateTransform>
						<animate
							attributeName="fill-opacity"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
							values="1;0"
							begin="-0.625s"
						></animate>
					</circle>
				</g>
			</g>
			<g transform="translate(28.786796564403577,71.21320343559643)">
				<g transform="rotate(135)">
					<circle cx="0" cy="0" r="6" fill="#ffffff" fill-opacity="0.625">
						<animateTransform
							attributeName="transform"
							type="scale"
							begin="-0.5s"
							values="1.5 1.5;1 1"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
						></animateTransform>
						<animate
							attributeName="fill-opacity"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
							values="1;0"
							begin="-0.5s"
						></animate>
					</circle>
				</g>
			</g>
			<g transform="translate(20,50.00000000000001)">
				<g transform="rotate(180)">
					<circle cx="0" cy="0" r="6" fill="#ffffff" fill-opacity="0.5">
						<animateTransform
							attributeName="transform"
							type="scale"
							begin="-0.375s"
							values="1.5 1.5;1 1"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
						></animateTransform>
						<animate
							attributeName="fill-opacity"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
							values="1;0"
							begin="-0.375s"
						></animate>
					</circle>
				</g>
			</g>
			<g transform="translate(28.78679656440357,28.786796564403577)">
				<g transform="rotate(225)">
					<circle cx="0" cy="0" r="6" fill="#ffffff" fill-opacity="0.375">
						<animateTransform
							attributeName="transform"
							type="scale"
							begin="-0.25s"
							values="1.5 1.5;1 1"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
						></animateTransform>
						<animate
							attributeName="fill-opacity"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
							values="1;0"
							begin="-0.25s"
						></animate>
					</circle>
				</g>
			</g>
			<g transform="translate(49.99999999999999,20)">
				<g transform="rotate(270)">
					<circle cx="0" cy="0" r="6" fill="#ffffff" fill-opacity="0.25">
						<animateTransform
							attributeName="transform"
							type="scale"
							begin="-0.125s"
							values="1.5 1.5;1 1"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
						></animateTransform>
						<animate
							attributeName="fill-opacity"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
							values="1;0"
							begin="-0.125s"
						></animate>
					</circle>
				</g>
			</g>
			<g transform="translate(71.21320343559643,28.78679656440357)">
				<g transform="rotate(315)">
					<circle cx="0" cy="0" r="6" fill="#ffffff" fill-opacity="0.125">
						<animateTransform
							attributeName="transform"
							type="scale"
							begin="0s"
							values="1.5 1.5;1 1"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
						></animateTransform>
						<animate
							attributeName="fill-opacity"
							keyTimes="0;1"
							dur="1s"
							repeatCount="indefinite"
							values="1;0"
							begin="0s"
						></animate>
					</circle>
				</g>
			</g>
		</svg>
	);
};

export default Gallery;

const ImageTextGallery = ({
	open,
	setOpen,
	images,
	imageText = null,
	clickedImageIndex = 0,
	breakpoint = 900,
}) => {
	const [visibleIndex, setVisbileIndex] = useState(0);
	const imagesRef = useRef();
	const isMobile = window.innerWidth < breakpoint;

	const indices = images ? images : imageText;

	//animation on opening and closing
	const openAnimation = open
		? {
				top: "0vh",
				opacity: 1,
				transition: "top 350ms ease-out, opacity 600ms ease-out",
		  }
		: {
				top: "100vh",
				opacity: 0,
				transition: "top 350ms ease-out, opacity 600ms ease-out",
		  };

	// const handleScroll = (e) => {
	// 	if (!isMobile) return;
	// 	const { scrollLeft } = e.target;
	// 	const scrollIndex = Math.round(scrollLeft / window.innerWidth);
	// 	setVisbileIndex(scrollIndex);
	// };

	//set scroll value on clicking direction arrows
	useEffect(() => {
		// if (isMobile) return;
		imagesRef.current.scrollLeft = window.innerWidth * visibleIndex;
	}, [visibleIndex]);

	useEffect(() => {
		// disable scroll on body when popup is open
		const bodyStyle = document.body.style;
		if (open) {
			bodyStyle.height = "100vh";
			// bodyStyle.overflowY = "hidden";
		} else {
			bodyStyle.height = "auto";
			// bodyStyle.overflowY = "auto";
		}

		//disable swipe for desktop view
		imagesRef.current.style.pointerEvents = isMobile ? "auto" : "none";
		// imagesRef.current.style.pointerEvents = "none";

		//scroll to the clicked image on open
		if (open) {
			setTimeout(() => {
				imagesRef.current.scrollLeft = window.innerWidth * clickedImageIndex;
				setVisbileIndex(clickedImageIndex);
			}, 200);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	const close = (e) => {
		setOpen(false);
		e.stopPropagation();
	};

	return (
		<div className="__gallery" style={openAnimation} onClick={close}>
			<SvgCrossWhite id="gallery__cross" onClick={close} />

			<div
				className="gallery__images"
				ref={imagesRef}
				// onScroll={(e) => handleScroll(e)}
			>
				{/* Mobile popup */}
				{images?.map((image, index) => {
					const src = getImg({
						id: image.imageId ? image.imageId : image,
						version: "1636374075",
					});
					return (
						<div className="gallery__images-image" key={index}>
							<img src={src} alt="property" loading="lazy" />
						</div>
					);
				})}

				{/* Monitor popup */}
				{imageText?.map(({ image, description }, index) => {
					const src = getImg({
						id: image.ImgId,
						version: image.version,
					});
					return (
						<div className="image-description" key={index}>
							<img
								src={src}
								className="image-description__image"
								loading="lazy"
								alt="property"
							/>
							<p className="description">{description}</p>
						</div>
					);
				})}
			</div>

			<div className="gallery__arrows">
				<SvgArrowLeftWhite
					onClick={(e) => {
						e.stopPropagation();
						setVisbileIndex((prev) => {
							if (prev > 0) return prev - 1;
							return indices.length - 1;
						});
					}}
				/>
				<SvgArrowRightWhite
					onClick={(e) => {
						e.stopPropagation();
						setVisbileIndex((prev) => {
							if (prev < indices.length - 1) return prev + 1;
							return 0;
						});
					}}
				/>
			</div>

			<div className="gallery__index">
				<div className="text-sm-bold clr-white">
					{visibleIndex + 1} of {images?.length} {imageText?.length}
				</div>
			</div>
		</div>
	);
};
